import { trigger, state, animate, transition, style } from "@angular/animations";
export enum ProgressStatus {
  WAITING,
  RUNNING,
  SUCCESS,
  FAILURE,
}

export const PROGRESS_BAR_VALUE_ANIMATION = [
  trigger("animateState", [
    state(
      "waiting",
      style({
        backgroundColor: "#FFE653",
        // '$color_order_cancel_popup_container_progress-bar-value--background--WAITING'
        //            backgroundColor: '$var(--base_progress_bar_value--background--waiting)'
      }),
    ),
    state(
      "running",
      style({
        backgroundColor: "#FFE653",
        // '$color_order_cancel_popup_container_progress-bar-value--background--RUNNING'
        //            backgroundColor: '$var(--base_progress_bar_value--background--running)'
      }),
    ),
    state(
      "success",
      style({
        backgroundColor: "#379340",
        // '$color_order_cancel_popup_container_progress-bar-value--background--SUCCESS'
        //            backgroundColor: '$var(--base_progress_bar_value--background--success)'
      }),
    ),
    state(
      "failure",
      style({
        backgroundColor: "#AD1A26",
        // '$color_order_cancel_popup_container_progress-bar-value--background--FAILURE'
        //            backgroundColor: '$var(--base_progress_bar_value--background--failure)'
      }),
    ),
    transition("* => *", animate("200ms ease")),
  ]),
];

export const PROGRESS_BAR_VALUE_ANIMATIONS: any = {
  waiting: "base_progress_bar_value--background--waiting",
  running: "base_progress_bar_value--background--running",
  success: "base_progress_bar_value--background--success",
  failure: "base_progress_bar_value--background--failure",
};
